/**
 * Arduino Algolia Search
 * A replacement for header search due to theme migration and
 * uncompatible updated in plugin.
*/

class ArduinoSearch {
    constructor(containerSelector, toggleSelector) {
        this.container = document.querySelector(containerSelector);
        this.toggle = document.querySelector(toggleSelector);

        this.input = this.container.querySelector('.ino-search-input');
        this.clear = this.container.querySelector('.ino-search-clear');
        this.resultsContainer = this.container.querySelector('.ino-search-results');

        // this.overlay = document.querySelector('.ino-header__overlay');

        this.searchTimeout = null;
    }

    onToggleClick(event) {
        event.preventDefault();
        
        this.container.classList.toggle('visible');
        this.toggle.ariaExpanded = this.toggle.ariaExpanded == 'true' ? 'false' : 'true';
        this.input.focus();
    }

    onInputClick(event) {
        event.stopPropagation();
    }

    onClearClick(event) {
        event.stopPropagation();

        // reset input
        this.input.value = '';
        this.input.focus();

        // hide results
        this.resultsContainer.classList.remove('visible');
    }

    resetSearchResults() {
        const collectionsResultsContainer = this.resultsContainer.querySelector('.ino-search-collections-results');
        const productsResultsContainer = this.resultsContainer.querySelector('.ino-search-products-results');

        collectionsResultsContainer.innerHTML = '';
        productsResultsContainer.innerHTML = '';
    }

    getSearchResults(query, numProducts = 8, numCollections = 2) {
        const algoliaConfig = window.algoliaShopify.config;

        const searchResults = {
            collections: [],
            products: []
        };

        if(!algoliaConfig.app_id || !algoliaConfig.search_api_key) {
            return Promise.resolve(searchResults);
        }

        const algoliaClient = window.algoliaShopify.searchClient;
        const indexPrefix = algoliaConfig.index_prefix;

        const queries = [
            {indexName: `${indexPrefix}products`, query: query, params: {hitsPerPage: numProducts, distinct: true}},
            {indexName: `${indexPrefix}collections`, query: query, params: {hitsPerPage: numCollections, distinct: true}}
        ];

        return algoliaClient.multipleQueries(queries).then(({results}) => {
            for(let item of results) {
                if (item.hits === undefined || item.hits.length === 0) {
                    continue;
                }
                
                if(item.index === `${indexPrefix}products`) {
                    searchResults.products = item.hits.map((item, index, array) => {
                        
                        // let price = formatMoney(item.price * 100);

                        // if(item.variants_max_price !== item.variants_min_price) {
                        //     let min_price = formatMoney(item.variants_min_price * 100);
                        //     let max_price = formatMoney(item.variants_max_price * 100);

                        //     price = `${min_price} - ${max_price}`;
                        // }
                        
                        // let compareAtPrice = item.compare_at_price > 0 ? formatMoney(item.compare_at_price * 100) : 0;

                        return {
                            id: item.id,
                            title: item.title,
                            price: item.price,
                            minPrice: item.variants_min_price,
                            maxPrice: item.variants_max_price,
                            compareAtPrice: item.compare_at_price,
                            image: item.product_image,
                            category: item.product_type,
                            vendor: item.vendor,
                            url: `/products/${item.handle}`
                        };
                    });
                } else if(item.index === `${indexPrefix}collections`) {
                    searchResults.collections = item.hits.map((item, index, array) => {
                        return {
                            id: item.id,
                            title: item.title,
                            url: `/collections/${item.handle}`
                        };
                    });
                }
            }

            return searchResults;
        }).catch((error) => {
            console.error(error);
        });
    }

    renderProductPrice(product) {
        // format price or include price range
        // using here algolia helper function
        const formatMoney = window.algoliaShopify.formatMoney;

        let price = formatMoney(product.price * 100);

        if(product.maxPrice !== product.minPrice) {
            let minPrice = formatMoney(product.minPrice * 100);
            let maxPrice = formatMoney(product.maxPrice * 100);

            price = `${minPrice} - ${maxPrice}`;
        }

        let result = `
            <strong>${price}</strong>
        `;

        if(product.compareAtPrice > product.price) {
            let compareAtPrice = formatMoney(product.compareAtPrice * 100);

            result = `
                <span class="ino-price__compare-at">${compareAtPrice}</span>
                <strong class="ino-price__on-sale">${price}</strong>
            `;
        }

        return `
            <span class="ino-search-item-price">
                ${result}
            </span>
        `;
    }

    renderProductSearchResults(results, query) {
        const container = this.resultsContainer.querySelector('.ino-search-products-results');

        if(results.products.length > 0) {
            let resultsRendered = ``;

            for(let product of results.products) {
                let category = product.category;

                if(category.toLowerCase().includes(query.toLowerCase())) {
                    category = `<strong>${category}</strong>`;
                }

                let price = this.renderProductPrice(product);

                resultsRendered += `
                    <div class="ino-search-item">
                        <a href="${product.url}" title="${product.title}" target="_blank">
                            <div class="ino-search-item-image">
                                <img src="${product.image}" alt="${product.title}" />
                            </div>
                            <div class="ino-search-item-text">
                                <span class="ino-search-item-title">
                                    ${product.title}
                                </span>
                                <span class="ino-search-item-description">
                                    ${category} by ${product.vendor}
                                </span>
                                ${price}
                            </div>
                        </a>
                    </div>
                `;
            }

            container.innerHTML = resultsRendered;
        } else {
            container.innerHTML = `
                <div class="ino-search-empty">
                    <p>No results for query "${query}"</p>
                    <p>
                        <a href="/search?q=">See all products</a>
                    </p>
                </div>
            `;
        }
    }

    renderCollectionSearchResults(results, query) {
        const container = this.resultsContainer.querySelector('.ino-search-collections-results');

        if(results.collections.length > 0) {
            let resultsRendered = ``;

            for(let collection of results.collections) {
                let title = collection.title;

                if(title.toLowerCase().includes(query.toLowerCase())) {
                    let highlight = title.substring(0, query.length);
                    title = `<strong>${highlight}</strong>${title.substring(query.length)}`;
                }

                resultsRendered += `
                    <div class="ino-search-item">
                        <a href="${collection.url}" title="${collection.title}" target="_blank">
                            ${title}
                        </a>
                    </div>
                `;
            }

            container.innerHTML = resultsRendered;
        } else {
            container.innerHTML = '<div class="ino-search-empty">No collection found</div>';
        }
    }

    renderSearchResults(results, query) {
        this.renderProductSearchResults(results, query);
        this.renderCollectionSearchResults(results, query);
    }

    onSearchInput(event) {
        if(this.searchTimeout !== null) {
            clearTimeout(this.searchTimeout);
        }

        this.searchTimeout = setTimeout(() => {
            const query = event.target.value;

            if(query.trim().length > 0) {
                this.getSearchResults(query, 8, 2).then((results) => {
                    this.resetSearchResults();
                    this.renderSearchResults(results, query);

                    this.resultsContainer.classList.add('visible');
                });
            } else {
                this.resultsContainer.classList.remove('visible');
                this.resetSearchResults();
            }
        }, 500);
    }

    onClickAway(event) {
        if(event.target.closest('a') != this.toggle) {
            this.container.classList.remove('visible');
            this.toggle.ariaExpanded = 'false';
        }
    }

    onKeyDown(event) {
        if(event.key == 'Escape') {
            this.container.classList.remove('visible');
            this.toggle.ariaExpanded = 'false';
        }
    }

    init() {
        // click away event
        window.addEventListener('click', (event) => { this.onClickAway(event) });

        // reset container click event
        this.resultsContainer.addEventListener('click', (event) => { event.stopPropagation() });

        this.toggle.addEventListener('click', (event) => { this.onToggleClick(event) });
        this.clear.addEventListener('click', (event) => { this.onClearClick(event) });
        this.input.addEventListener('click', (event) => { this.onInputClick(event) });
        this.input.addEventListener('input', (event) => { this.onSearchInput(event) });

        // for keyboard users
        window.addEventListener('keydown', (event) => { this.onKeyDown(event) });
    }
}

(function() {
    window.addEventListener('load', () => {
        const desktopSearch = new ArduinoSearch('.ino-search--desktop', '.ino-search-toggle--desktop');
        desktopSearch.init();

        const mobileSearch = new ArduinoSearch('.ino-search--mobile', '.ino-search-toggle--mobile');
        mobileSearch.init();
    });
})();